<template>
  <div class="filters">
    <div class="filters__mobile">
      <button class="filters__mobile--button" v-on:click="toggleFilters()">
        <span>{{ $lang.filters.choose }}</span>
        <div class="filter__header--icon"><i></i></div>
      </button>
    </div>
    <div class="filters__box">
      <div class="filters__box__content" v-bind:class="{'filters__box--active': isActiveFilters}">
        <div class="filters__box__close">
          <button v-on:click="toggleFilters()">{{ $lang.filters.close }}</button>
        </div>
        <div class="filters__box__list">
          <div class="filters__box__title">
            <h3 class="filters__box__header">
              {{ $lang.filters.choose }}
            </h3>
          </div>
          <div class="filters__item filters__item--language filter"
               is="search-filter"
               name="language"
               v-bind:values="filtersFields.language">
          </div>
          <div class="filters__item filters__item--data-provider filter"
               is="search-filter"
               name="data_provider"
               v-bind:values="filtersFields.data_provider">
          </div>
          <div class="filters__item filters__item--place-of-publishing filter"
               is="search-filter"
               name="place_of_publishing"
               v-bind:values="filtersFields.place_of_publishing">
          </div>
          <div class="filters__item filters__item--date filter"
               is="search-date-filter">
          </div>
          <div class="filters__bottom filters__box__clear">
            <button v-if="isFiltersSet || isDateSet" class="filters__bottom--clear" v-on:click="resetFilters()">
              {{ $lang.filters.clear_all }}
            </button>
          </div>
        </div>
      </div>
      <div class="filters__bottom">
        <button v-if="isFiltersSet || isDateSet" class="filters__bottom--clear" v-on:click="resetFilters()">
          {{ $lang.filters.clear_all }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters} from 'vuex'
import SearchFilter from './../Search/SearchFilter'
import SearchDateFilter from './../Search/SearchDateFilter'
import * as filterModule from '../../scripts/modules/filter'
import * as dateFiltersSetters from '../../scripts/modules/store/date-filters-setters'
import * as dateFilterModule from '../../scripts/modules/date-filter'
import * as searchModule from '../../scripts/modules/search'

export default {
  name: 'filters',
  components: {
    'search-filter': SearchFilter,
    'search-date-filter': SearchDateFilter
  },
  data () {
    return {
    }
  },
  methods: {
    toggleFilters () {
      return this.$store.commit('SET_IS_FILTER_BOX', !this.isActiveFilters)
    },
    resetFilters() {
      // resets filters
      filterModule.resetFilters()
      // restes date range
      dateFiltersSetters.resetDateRange()
      // reset date validation
      dateFilterModule.setValidDates()
      // reload results
      searchModule.loadResultsWithDataPreload()

    }
  },
  computed: {
    isActiveFilters: {
      get () {
        return this.$store.getters.GET_IS_FILTER_BOX
      }
    },
    isFiltersSet: {
      get () {
        return (this.$store.getters.GET_FILTER_PARAMS && this.$store.getters.GET_FILTER_PARAMS.length)
      }
    },
    isDateSet: {
      get () {
        return this.$store.getters.GET_IS_DATE_SET
      }
    },
    ...mapGetters({
      filtersFields: 'GET_FILTERS_FIELDS'
    })
  }
}
</script>



// WEBPACK FOOTER //
// SearchFilters.vue?85fe806c